/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type BottomBar_viewer$ref = any;
type MessageBanner_user$ref = any;
type MessageBanner_viewer$ref = any;
type TopBar_user$ref = any;
type TopBar_viewer$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type TradeFirmSalesTier = "P_AND_M" | "TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "UNKNOWN" | "%future added value";
export type Header_viewer$ref = any;
export type Header_viewer = {
    readonly submittedTransactions?: {
        readonly totalResults: number | null;
    } | null;
    readonly confirmedTransactionsMostRecent?: {
        readonly totalResults: number | null;
    } | null;
    readonly vipChatEmail?: ReadonlyArray<{
        readonly userDataB: ReadonlyArray<({
            readonly email?: string | null;
        } & ({
            readonly email: string | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null> | null;
    } | null> | null;
    readonly tradeChatEmail?: ReadonlyArray<{
        readonly userDataB: ReadonlyArray<({
            readonly email?: string | null;
        } & ({
            readonly email: string | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null> | null;
    } | null> | null;
    readonly allTransactions?: {
        readonly totalResults: number | null;
    } | null;
    readonly initiatedTransactions?: {
        readonly totalResults: number | null;
    } | null;
    readonly confirmedTransactions?: {
        readonly totalResults: number | null;
    } | null;
    readonly user?: {
        readonly createdDate: string | null;
        readonly firstSessionDate: string | null;
        readonly isTrade: boolean | null;
        readonly hasVipPermission: boolean | null;
        readonly authMetadata: {
            readonly emailOnly: boolean | null;
            readonly hasPassword: boolean | null;
        } | null;
        readonly profile: {
            readonly email: string | null;
            readonly zipCode: string | null;
            readonly currency: Currency | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
        } | null;
        readonly serviceId: string | null;
        readonly totalMessagesToDealers: number | null;
        readonly tradeFirm: {
            readonly serviceId: string | null;
            readonly tier: TradeFirmSalesTier | null;
            readonly profileStatus: DesignProfileStatus | null;
            readonly rewards: {
                readonly currentProgram: {
                    readonly programInfo: {
                        readonly code: string | null;
                    } | null;
                } | null;
            } | null;
        } | null;
        readonly verifiedTradeStatus: string | null;
        readonly mentionMeTagParameters: {
            readonly ciphertext: string | null;
            readonly nonce: string | null;
        } | null;
        readonly roles: {
            readonly roleList: ReadonlyArray<{
                readonly name: string | null;
                readonly createdDate: string | null;
                readonly userData: {
                    readonly userStatus: {
                        readonly name: string | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
        readonly isVip: boolean | null;
        readonly isVerifiedTrade: boolean | null;
        readonly " $fragmentRefs": MessageBanner_user$ref & TopBar_user$ref;
    } | null;
    readonly regionalInfo?: ReadonlyArray<{
        readonly zipCode: string | null;
        readonly incomeLevel: {
            readonly incomeBracket: string | null;
            readonly incomePercentile: string | null;
        } | null;
        readonly currency: string | null;
    } | null> | null;
    readonly " $fragmentRefs": BottomBar_viewer$ref & TopBar_viewer$ref & MessageBanner_viewer$ref;
    readonly " $refType": Header_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds"
    } as any), v1 = ({
        "kind": "Literal",
        "name": "first",
        "value": 0
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
        } as any)
    ], v3 = ({
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.confirmed"
    } as any), v4 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        (v5 /*: any*/)
    ], v7 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdDate",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zipCode",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "Header_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "showMarketingMessages",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "fetchRegionalInfo",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "userIds",
                "type": "[String]!"
            },
            {
                "kind": "RootArgument",
                "name": "zipCode",
                "type": "String"
            }
        ],
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "BottomBar_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "TopBar_viewer",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "submittedTransactions",
                        "name": "transactions",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "viewName",
                                "value": "buyerTracking.submitted"
                            }
                        ],
                        "concreteType": "TransactionConnection",
                        "plural": false,
                        "selections": (v2 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "confirmedTransactionsMostRecent",
                        "name": "transactions",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            (v3 /*: any*/)
                        ],
                        "concreteType": "TransactionConnection",
                        "plural": false,
                        "selections": (v2 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "vipChatEmail",
                        "name": "userRelationships",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "relationshipType",
                                "value": "VIP"
                            },
                            (v4 /*: any*/)
                        ],
                        "concreteType": "UserRelationship",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "userDataB",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "type": "VipRepData",
                                        "selections": (v6 /*: any*/)
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "tradeChatEmail",
                        "name": "userRelationships",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "relationshipType",
                                "value": "TRADE"
                            },
                            (v4 /*: any*/)
                        ],
                        "concreteType": "UserRelationship",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "userDataB",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "type": "TradeRepData",
                                        "selections": (v6 /*: any*/)
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "allTransactions",
                        "name": "transactions",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            (v1 /*: any*/)
                        ],
                        "concreteType": "TransactionConnection",
                        "plural": false,
                        "selections": (v2 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "initiatedTransactions",
                        "name": "transactions",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "viewName",
                                "value": "buyerTracking.initiated"
                            }
                        ],
                        "concreteType": "TransactionConnection",
                        "plural": false,
                        "selections": (v2 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "confirmedTransactions",
                        "name": "transactions",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "sort",
                                "value": "createdDate asc"
                            },
                            (v3 /*: any*/)
                        ],
                        "concreteType": "TransactionConnection",
                        "plural": false,
                        "selections": (v2 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": (v7 /*: any*/),
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            (v8 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "firstSessionDate",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": "isTrade",
                                "name": "hasPermission",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "name",
                                        "value": "B_VERIFIED_TRADE"
                                    }
                                ],
                                "storageKey": "hasPermission(name:\"B_VERIFIED_TRADE\")"
                            },
                            {
                                "kind": "ScalarField",
                                "alias": "hasVipPermission",
                                "name": "hasPermission",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "name",
                                        "value": "B_VIP_CHECKOUT"
                                    }
                                ],
                                "storageKey": "hasPermission(name:\"B_VIP_CHECKOUT\")"
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "authMetadata",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserExistsMetadataType",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "emailOnly",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "hasPassword",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "profile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Profile",
                                "plural": false,
                                "selections": [
                                    (v5 /*: any*/),
                                    (v9 /*: any*/),
                                    (v10 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "firstName",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "lastName",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            (v11 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "totalMessagesToDealers",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "tradeFirm",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmType",
                                "plural": false,
                                "selections": [
                                    (v11 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "tier",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "profileStatus",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "rewards",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "TradeFirmRewards",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "currentProgram",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ParentProgram",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "programInfo",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "LoyaltyProgram",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "alias": null,
                                                                "name": "code",
                                                                "args": null,
                                                                "storageKey": null
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "verifiedTradeStatus",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "mentionMeTagParameters",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "mentionMeTagParameters",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "ciphertext",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "nonce",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "roles",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserRoles",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "roleList",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Role",
                                        "plural": true,
                                        "selections": [
                                            (v12 /*: any*/),
                                            (v8 /*: any*/),
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "userData",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "UserRoleData",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "userStatus",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "UserRoleUserData",
                                                        "plural": false,
                                                        "selections": [
                                                            (v12 /*: any*/)
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isVip",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isVerifiedTrade",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "showMarketingMessages",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "MessageBanner_user",
                                        "args": null
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "TopBar_user",
                                "args": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "showMarketingMessages",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "MessageBanner_viewer",
                        "args": null
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchRegionalInfo",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "regionalInfo",
                        "storageKey": null,
                        "args": (v7 /*: any*/),
                        "concreteType": "RegionalInfo",
                        "plural": true,
                        "selections": [
                            (v9 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "incomeLevel",
                                "storageKey": null,
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "zipCode",
                                        "variableName": "zipCode"
                                    }
                                ],
                                "concreteType": "IncomeLevel",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "incomeBracket",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "incomePercentile",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            (v10 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '89fd416f46fa01a9ff83a0698546e081';
export default node;
